<!--
 * @Author: xcy
 * @Date: 2021-04-28 16:00:24
 * @LastEditTime: 2023-02-08 20:17:03
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: 
-->
<template>
  <div style="height: 100vh; overflow: hidden">
    <div class="home">
      <div class="main-home">
        <div class="leftContainer">
          <keep-alive>
            <router-view />
          </keep-alive>
          <!-- <div class="footer">
            <bottom />
          </div> -->
        </div>
        <!-- <div class="rightContainer">
          <div class="right_box">
            <Sidebar />
          </div>
        </div> -->
      </div>
    </div>
    <!-- 扫码验证 -->
    <div class="query-verification" v-if="false">
      <query-verification />
    </div>
    <div v-if="showOverlay">
      <van-overlay :show="show" @click="hShow">
        <div class="wrapper">
          <div class="block">
            <img
              :src="list.welcome_image"
              alt=""
              style="width: 100%; height: 100%"
            />
            <div class="f-info">{{ list.welcome_message }}</div>
            <div>
              <img src="../assets/images/关闭按钮.png" alt="" />
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Overlay } from "vant";
Vue.use(Overlay);
// import Sidebar from "@/components/Sidebar";
import QueryVerification from "../components/Query";
// import bottom from "./bottom.vue";
export default {
  data() {
    return {
      showOverlay: false,
      show: true,
      list: [],
    };
  },
  created() {
    this.list = JSON.parse(localStorage.getItem("wel"));
    console.log("wwwwwwwwwwww", this.list);
  },
  mounted() {
    if (this.list.welcome_image) {
      this.showOverlay = true;
    }
    //   if (!localStorage.getItem("show")) {
    //     this.showOverlay = true;
    //     localStorage.setItem("show", "ture");
    //   }
  },
  methods: {
    hShow() {
      this.show = false;
      this.showOverlay = false;
    },
  },
  components: {
    // Sidebar,
    QueryVerification,
    // bottom,
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .t-info {
    text-align: center;
    width: 280px;
    height: 80px;
    line-height: 80px;
  }
  .f-info {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 52px;
    color: #ffffff;
    opacity: 1;
    text-align: center;
    width: 392px;
    height: 92px;
    // margin-bottom: 166px;
    position: absolute;
  }
  width: 554px;
  height: 646px;
}
.home {
  display: flex;
  // background-color: #269079;

  // padding: 11px 0 0px 0;
  // background-color: #26907a;
  flex-direction: column;
  .main-home {
    display: flex;
  }

  .leftContainer {
    // padding: 48px 20px;
    // padding: 48px 0;
    min-height: 1800px;
    height: calc(100vh - 0px);
    box-sizing: border-box;
    overflow: scroll;
    width: 990px;
    background-color: #f0f0f0;
    // box-shadow: inset 7px -8px 20px 0px #e6e6e6;
    padding-bottom: 45px;
    // border-radius: 0px 32px 32px 0px;
    .footer {
      margin-top: 30px;
    }
  }

  @media screen and (min-width: 376px) and (max-width: 414px) {
    .leftContainer {
      width: 118.6vw;
    }
  }

  .rightContainer {
    // margin-top: 40px;
    // padding-top: 40px;
    width: 128px;
    height: calc(100vh - 48px);
    overflow: hidden;
  }
  .right_box {
    height: calc(100vh - 88px);
    overflow: scroll;
    background-color: #269079;
  }
}
.query-verification {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 9999;
}
// .query-verification{
//     width: 100%;

//     padding-top: 48px;

//     // background: #000;

//   }
</style>
